import { sort_order } from '../Common/types';

export const filterSortDefaults = {
  query: '',
  sort_by: 'created_at',
  sort_order: sort_order.asc,
  sent_to_fortnox: false,
};
